/**
 * This file contains typography definitions (not all, just the ones needed for components)
 * to be used within components that have a custom style.
 * This file is useful while we don't have a Typography component.
 */

var typography = theme => ({
  body: {
    fontFamily: theme.typography.family0,
    fontSize: theme.typography.size0,
    lineHeight: theme.typography.lineHeight2,
    ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
      fontSize: theme.typography.size1,
      lineHeight: theme.typography.lineHeight3
    },
    ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
      fontSize: theme.typography.size2,
      lineHeight: theme.typography.lineHeight3
    }
  },
  bodyLarge: {
    fontFamily: theme.typography.family0,
    lineHeight: theme.typography.lineHeight2,
    fontSize: theme.typography.size1,
    ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
      fontSize: theme.typography.size2,
      lineHeight: theme.typography.lineHeight3
    },
    ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
      fontSize: theme.typography.size3,
      lineHeight: theme.typography.lineHeight3
    }
  },
  caption: {
    fontFamily: theme.typography.family0,
    fontSize: theme.typography.size1,
    lineHeight: theme.typography.lineHeight2
  },
  captionSmall: {
    fontFamily: theme.typography.family0,
    fontSize: theme.typography.size0,
    lineHeight: theme.typography.lineHeight1
  },
  label: {
    fontFamily: theme.typography.family0,
    fontSize: theme.typography.size2,
    lineHeight: theme.typography.lineHeight2
  },
  labelSmall: {
    fontFamily: theme.typography.family0,
    fontSize: theme.typography.size0,
    lineHeight: theme.typography.lineHeight1
  },
  fontMedium: {
    fontWeight: theme.typography.weight4,
    fontFamily: theme.typography.family0
  },
  subtitleRegular: {
    fontFamily: theme.typography.family0,
    fontSize: theme.typography.size4,
    lineHeight: theme.typography.lineHeight4
  }
});
export default typography;